export default "__VITE_ASSET__6uF1oUfe__"